import module from 'app/module.js'
import template from './template.html'

class SearchboxListaComponent {
  data = null
  limite = null
  tipo = ''
  resultados = []

  $onChanges () {
    this.resultados = (Array.isArray(this.data) && this.data.length)
      ? this.data.slice(0, this.limite)
      : []
  }
}

module.component('searchboxLista', {
  controller: SearchboxListaComponent,
  template,
  bindings: {
    data: '<',
    limite: '<',
    tipo: '<',
  },
})



// WEBPACK FOOTER //
// ./src/app/components/searchbox/lista/component.js